module.exports = __webpack_public_path__ + "static/media/foto-contato.bdd4ce54.jpg";